import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    TASKS: "Задачи",
    START_METHODS: "Запустить методы",
    buildSelected: (countMethods, countTasks) => `${countMethods} ${buildCorrectGrammarText(countMethods, [
        "метод",
        "метода",
        "методов"
    ])} / ${countTasks} ${buildCorrectGrammarText(countTasks, ["задача", "задачи", "задач"])}`
};
